const EyeIcon = () => {
  return (
    <svg width='16' height='17' viewBox='0 0 16 17' fill='none'>
      <path
        d='M1.61341 9.4097C1.52262 9.26594 1.47723 9.19406 1.45182 9.08319C1.43273 8.99991 1.43273 8.86858 1.45182 8.7853C1.47723 8.67443 1.52262 8.60255 1.61341 8.45879C2.36369 7.27081 4.59693 4.26758 8.00027 4.26758C11.4036 4.26758 13.6369 7.2708 14.3871 8.45879C14.4779 8.60255 14.5233 8.67443 14.5487 8.7853C14.5678 8.86858 14.5678 8.99991 14.5487 9.08319C14.5233 9.19406 14.4779 9.26594 14.3871 9.4097C13.6369 10.5977 11.4036 13.6009 8.00027 13.6009C4.59693 13.6009 2.36369 10.5977 1.61341 9.4097Z'
        stroke='white'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.00027 10.9342C9.10484 10.9342 10.0003 10.0388 10.0003 8.93424C10.0003 7.82968 9.10484 6.93424 8.00027 6.93424C6.8957 6.93424 6.00027 7.82968 6.00027 8.93424C6.00027 10.0388 6.8957 10.9342 8.00027 10.9342Z'
        stroke='white'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default EyeIcon;
